import type { FilesValue, FormFile } from '../../common/types/form/form-fields/field-values';

export const getAttachmentValue = (
	files: { id: string; name?: string }[] | null,
): FilesValue | undefined => {
	if (files === null) {
		return undefined;
	}
	// NOTE: Only ID and name are defined when we initially load a ProformaForm so we can only set
	// default values for the other properties. The other values are not stored in the Proforma form.
	return {
		files: files.map<FormFile>((file) => ({
			creationDate: 0,
			identifier: {
				id: file.id,
				mediaItemType: 'file',
			},
			name: file.name ?? '',
			size: 0,
			type: 'file',
		})),
	};
};
